import { createSelector } from 'reselect';
import { NAME } from '../redux/errors/errors';

const selectError = (state) => state[NAME];

export const selectErrorMessage = createSelector(selectError, ({ message }) => message);
